import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import { Checkbox, Dropdown } from 'semantic-ui-react';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);
export default function CenterPanelView(props) {
  const getSelectedCallQuality = (value) => {
    for (let i in props.callQualityOptions) {
      if (value == props.callQualityOptions[i].value) {
        return props.callQualityOptions[i].text;
      }
    }
  };

  const displayMessageAfterTime = () => {
    // If 1 minute, display '1 minute'; if 0 seconds, should not show '0 seconds'; if 0 minute, show '0 minutes'
    let messageDisplayAfterTime = '';
    let messageDisplayAfterSecondsText = '';
    if (props.duringCallsForm.displayMessageMinutes == 1) {
      messageDisplayAfterTime = APP.LANGUAGE.DuringCallsModal.DisplayMsgAfter.replace(
        '##minutes##',
        props.duringCallsForm.displayMessageMinutes
      ).replace('##minutesText##', 'minute');
    } else {
      messageDisplayAfterTime = APP.LANGUAGE.DuringCallsModal.DisplayMsgAfter.replace(
        '##minutes##',
        props.duringCallsForm.displayMessageMinutes
      ).replace('##minutesText##', 'minutes');
    }
    if (props.duringCallsForm.displayMessageSeconds > 0) {
      if (props.duringCallsForm.displayMessageSeconds == 1) {
        messageDisplayAfterSecondsText = APP.LANGUAGE.DuringCallsModal.DisplayMsgAfterSecondsText.replace(
          '##seconds##',
          props.duringCallsForm.displayMessageSeconds
        ).replace('##secondsText##', 'second');
      } else {
        messageDisplayAfterSecondsText = APP.LANGUAGE.DuringCallsModal.DisplayMsgAfterSecondsText.replace(
          '##seconds##',
          props.duringCallsForm.displayMessageSeconds
        ).replace('##secondsText##', 'seconds');
      }
    } else {
      messageDisplayAfterSecondsText = '.';
    }

    return messageDisplayAfterTime + messageDisplayAfterSecondsText;
  };

  const getToggelText = (value) => {
    return value ? 'ON' : 'OFF';
  };

  let messageToDisplay = props.duringCallsForm.message.substr(0, 480);
  if (messageToDisplay === null || messageToDisplay === '') {
    messageToDisplay = APP.LANGUAGE.DuringCallsModal.MessageToDisplay;
  }
  let isRecordingEnabled = props.duringCallsForm.isRecordingEnabled == true ? 'Yes' : 'No';

  return (
    <div className="ui form mrbm">
      <div>
        <div className="max-width mrbm">
          <div className="placeholder-label color-placeholder">{APP.LANGUAGE.DuringCallsModal.CallQualityTitle}</div>
          <div className="title-sms">{getSelectedCallQuality(props.duringCallsForm.callQuality)}</div>
          <div className="placeholder-label color-placeholder mrtm">
            {APP.LANGUAGE.DuringCallsModal.MessageToDisplay}
          </div>
          <div className="div-as-textArea-wrapper">
            <div
              className={
                messageToDisplay === APP.LANGUAGE.DuringCallsModal.MessageToDisplay
                  ? 'div-as-textArea read-only'
                  : 'div-as-textArea read-only minHeightTextareaMedium'
              }
            >
              {htmlToReactParser.parse(xss(messageToDisplay))}
            </div>
          </div>
          {props.duringCallsForm.message == (null || '') ? (
            ''
          ) : (
            <div className="title-sms mrtm">{displayMessageAfterTime()}</div>
          )}
          {props.isRecordingAvailableOnPortal === true ? (
            <div className="mrtm clearfix">
              <span className="sms-title inline-flex pdbxs mrtm mrrs">
                {APP.LANGUAGE.DuringCallsModal.IfRecorded + ' ' + isRecordingEnabled}
              </span>
            </div>
          ) : (
            ''
          )}
          {/* Show each caller their position in queue */}
          <div className="mrtm clearfix">
            <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
              <div className="toggle-box mrrs">
                <div className="toggle-text text-size-ms">
                  {getToggelText(props.duringCallsForm.showCallerQueuePosition)}
                </div>
                <Checkbox toggle disabled={true} checked={props.duringCallsForm.showCallerQueuePosition} />
              </div>
              <div className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left">
                {APP.LANGUAGE.DuringCallsModal.ShowCallerQueuePosition}
              </div>
            </div>
            <div className="display-flex" data-show={!props.duringCallsForm.enableCalculateQueuePosition}>
              <div className="toggle-box-space" />
              <div className="ui basic label no-bold borderless pdtsss pdbxxs pdrnull">
                {APP.LANGUAGE.DuringCallsModal.CallerQueuePositionSubtitle}
              </div>
            </div>
          </div>
          {props.isWaitingAreaBulletinEnabled ? (
            <div className="mrtm">
              <div className="ui labeled button display-flex center-flex mrts" id="device-enable-check-session">
                <div className="toggle-box mrrs">
                  <div className="toggle-text text-size-ms">
                    {getToggelText(props.duringCallsForm.showWaitingAreaBulletin)}
                  </div>
                  <Checkbox toggle disabled={true} checked={props.duringCallsForm.showWaitingAreaBulletin} />
                </div>
                <div className="ui no-bold title-sms pdtsss pdbxxs pdrnull txt-left">
                  {APP.LANGUAGE.DuringCallsModal.ShowBackdrop}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
